<app-breadcrumb [pathList]="pathList"></app-breadcrumb>
<div [ngBusy]="{busy: busy, message: 'Loading...', backdrop: false, delay: 0, minDuration: 600}"></div>
<div class="container-fluid">
    <app-single-crest (pathListEvent)="loga($event)" [id]="id" [single]="single" [componentService]="CrestService" [routePart]="'shirt'" [part]="ShirtPart"></app-single-crest>
    <app-alertbox #alertbox1 [alerts]=""></app-alertbox>
</div>